import React from 'react';

import { AdfoxBanner, bannerLoadable } from './AdfoxBanner';
import {
  CAMPAIGNS,
  LT_PARTNER,
  WL_PARTNER,
  ALLOWED_INDEXES,
  HOTEL_LIST_BANNER_DESKTOP,
  HOTEL_LIST_BANNER_MOBILE,
} from './constants';

type BannerConfigParamsType = {
  p1: string;
  p2: string;
  puid1: string;
  puid2: string;
  puid3: string;
};

type BannerConfigType = {
  ownerId: number;
  containerId: string;
  params: BannerConfigParamsType;
};

// Возвращает конфиг баннера если для данного баннерного места он задан
export const getHotelListBannerConfig = (
  index: number,
  type: string,
  isMobile: boolean,
  isWhitelabel?: boolean,
): BannerConfigType | undefined => {
  if (!ALLOWED_INDEXES.includes(index)) return undefined;

  if (!bannerLoadable(type)) return undefined;

  const partner = isWhitelabel ? WL_PARTNER : LT_PARTNER;
  const bannerVariant =
    !isWhitelabel && isMobile
      ? HOTEL_LIST_BANNER_MOBILE
      : HOTEL_LIST_BANNER_DESKTOP;

  return CAMPAIGNS[partner][bannerVariant][index.toString()];
};

interface IHotelListBanner {
  index: number;
  type: string;
  className?: string;
  isWhitelabel?: boolean;
  isMobile: boolean;
}

export const HotelListBanner: React.FC<IHotelListBanner> = ({
  index,
  type,
  className = '',
  isWhitelabel = false,
  isMobile,
}) => {
  const bannerConfig = getHotelListBannerConfig(
    index,
    type,
    isMobile,
    isWhitelabel,
  );

  if (!bannerConfig) {
    return null;
  }

  const { ownerId, containerId, params } = bannerConfig;

  return (
    <AdfoxBanner
      params={params}
      ownerId={ownerId}
      className={className}
      containerId={`${containerId}_${index}`}
      type={type}
    />
  );
};
